import { useEffect } from 'react';

interface ConfirmDialogProps {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  danger?: boolean;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Small confirm modal on the portal's existing `partner-modal` shell. */
function ConfirmDialog({ title, body, confirmLabel, cancelLabel, danger, busy, error, onConfirm, onCancel }: ConfirmDialogProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);

  return (
    <div className="partner-modal-overlay" onClick={() => !busy && onCancel()}>
      <div
        className="partner-modal offer-confirm"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="offer-confirm-title"
        aria-describedby="offer-confirm-body"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="partner-modal-body">
          <h3 id="offer-confirm-title" className="offer-confirm__title">{title}</h3>
          <p id="offer-confirm-body" className="offer-confirm__body">{body}</p>
          {error && <div className="error-message" role="alert">{error}</div>}
          <div className="offer-confirm__actions">
            <button type="button" className="partner-modal-btn-cancel" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
            <button
              type="button"
              className={danger ? 'partner-modal-btn-danger' : 'partner-modal-btn-primary'}
              onClick={onConfirm}
              disabled={busy}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
